<template>
  <div>
    <div class="header">
      <van-nav-bar :title="$t('market')"> </van-nav-bar>
    </div>
    <div class="maincontent">
      <van-tabs
        class="menutabs"
        style="margin-bottom: 0.5rem"
        type="card"
        v-model="intval_index"
        @change="change"
      >
        <van-tab :title="$t('collect')">
          <div
            data-v-e6db21c0=""
            class="goods-markets-box"
            style="padding-bottom: 0"
          >
            <div data-v-e6db21c0="">
              <div
                data-v-e6db21c0=""
                class="markets-main-list"
                v-for="(item, index) in productlist"
                @click="totrade(item.gcode)"
              >
                <div data-v-e6db21c0="" class="markets-icon markets-icon1">
                  <img
                    data-v-e6db21c0=""
                    class="imgs-icon1 goods-icon1"
                    :src="item.logo"
                    alt=""
                    srcset=""
                  />
                  <div data-v-e6db21c0="" class="markets-name">
                    {{ item.name }}
                    <div data-v-e6db21c0="" class="names">
                      {{ item.fullname }}
                    </div>
                  </div>
                </div>
                <div data-v-e6db21c0="" class="markets-chart">
                  <mytrend2
                    :n5data="item.kdata"
                    :productid="item.id"
                    :linecolor="item.change > 0 ? '#c2e22a' : '#ce7735'"
                  />
                </div>
                <div data-v-e6db21c0="" class="markets-number">
                  <span data-v-e6db21c0="" id="btcusdt_price">{{
                    item.close
                  }}</span>
                  <div
                    data-v-e6db21c0=""
                    class="rersult_succsee"
                    id="btcusdt_change"
                    v-if="item.type"
                  >
                    {{ item.change }}%
                  </div>
                  <div
                    data-v-e6db21c0=""
                    class="rersult"
                    id="btcusdt_change"
                    v-else
                  >
                    {{ item.change }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab :title="$t('currency')">
          <div
            data-v-e6db21c0=""
            class="goods-markets-box"
            style="padding-bottom: 0"
          >
            <div data-v-e6db21c0="">
              <div
                data-v-e6db21c0=""
                class="markets-main-list"
                v-for="(item, index) in productlist"
                @click="totrade(item.gcode)"
              >
                <div data-v-e6db21c0="" class="markets-icon markets-icon1">
                  <img
                    data-v-e6db21c0=""
                    class="imgs-icon1 goods-icon1"
                    :src="item.logo"
                    alt=""
                    srcset=""
                  />
                  <div data-v-e6db21c0="" class="markets-name">
                    {{ item.name }}
                    <div data-v-e6db21c0="" class="names">
                      {{ item.fullname }}
                    </div>
                  </div>
                </div>
                <div data-v-e6db21c0="" class="markets-chart">
                  <mytrend2
                    :n5data="item.kdata"
                    :productid="item.id"
                    :linecolor="item.change > 0 ? '#c2e22a' : '#ce7735'"
                  />
                </div>
                <div data-v-e6db21c0="" class="markets-number">
                  <span data-v-e6db21c0="" id="btcusdt_price">{{
                    item.close
                  }}</span>
                  <div
                    data-v-e6db21c0=""
                    class="rersult_succsee"
                    id="btcusdt_change"
                    v-if="item.type"
                  >
                    {{ item.change }}%
                  </div>
                  <div
                    data-v-e6db21c0=""
                    class="rersult"
                    id="btcusdt_change"
                    v-else
                  >
                    {{ item.change }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="外汇" v-if="false">
          <div
            data-v-e6db21c0=""
            class="goods-markets-box"
            style="padding-bottom: 0"
          >
            <div data-v-e6db21c0="">
              <div
                data-v-e6db21c0=""
                class="markets-main-list"
                v-for="(item, index) in productlist"
                @click="totrade(item.gcode)"
              >
                <div data-v-e6db21c0="" class="markets-icon markets-icon1">
                  <img
                    data-v-e6db21c0=""
                    class="imgs-icon1 goods-icon1"
                    :src="item.logo"
                    alt=""
                    srcset=""
                  />
                  <div data-v-e6db21c0="" class="markets-name">
                    {{ item.name }}
                    <div data-v-e6db21c0="" class="names">
                      {{ item.fullname }}
                    </div>
                  </div>
                </div>
                <div data-v-e6db21c0="" class="markets-chart">
                  <mytrend2
                    :n5data="productlist2[index]['kdata']['lines']"
                    :productid="item.id"
                    :linecolor="item.change > 0 ? '#c2e22a' : '#ce7735'"
                  />
                </div>
                <div data-v-e6db21c0="" class="markets-number">
                  <span data-v-e6db21c0="" id="btcusdt_price">{{
                    item.close
                  }}</span>
                  <div
                    data-v-e6db21c0=""
                    class="rersult_succsee"
                    id="btcusdt_change"
                    v-if="item.type"
                  >
                    {{ item.change }}%
                  </div>
                  <div
                    data-v-e6db21c0=""
                    class="rersult"
                    id="btcusdt_change"
                    v-else
                  >
                    {{ item.change }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="期货" v-if="false">
          <div
            data-v-e6db21c0=""
            class="goods-markets-box"
            style="padding-bottom: 0"
          >
            <div data-v-e6db21c0="">
              <div
                data-v-e6db21c0=""
                class="markets-main-list"
                v-for="(item, index) in productlist"
                @click="totrade(item.gcode)"
              >
                <div data-v-e6db21c0="" class="markets-icon markets-icon1">
                  <img
                    data-v-e6db21c0=""
                    class="imgs-icon1 goods-icon1"
                    :src="item.logo"
                    alt=""
                    srcset=""
                  />
                  <div data-v-e6db21c0="" class="markets-name">
                    {{ item.name }}
                    <div data-v-e6db21c0="" class="names">
                      {{ item.fullname }}
                    </div>
                  </div>
                </div>
                <div data-v-e6db21c0="" class="markets-chart">
                  <mytrend2
                    :n5data="productlist2[index]['kdata']['lines']"
                    :productid="item.id"
                    :linecolor="item.change > 0 ? '#c2e22a' : '#ce7735'"
                    v-if="showmy"
                  />
                </div>
                <div data-v-e6db21c0="" class="markets-number">
                  <span data-v-e6db21c0="" id="btcusdt_price">{{
                    item.close
                  }}</span>
                  <div
                    data-v-e6db21c0=""
                    class="rersult_succsee"
                    id="btcusdt_change"
                    v-if="item.type"
                  >
                    {{ item.change }}%
                  </div>
                  <div
                    data-v-e6db21c0=""
                    class="rersult"
                    id="btcusdt_change"
                    v-else
                  >
                    {{ item.change }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import mytrend2 from '@/components/trend2.vue'
import '../../assets/css/index-c925edae.css'
export default {
  components: { mytrend2 },
  data() {
    return {
      intval_index: 1,
      newslist: [],
      productlist: [],
      productlist2: [],
      zxlist: [],
      activeindex: 0,
      type: 'Crypto',
      wk: null,
      timers: null,
      symbol: '',
      showmy: false,
    }
  },
  created() {
    this.getproduct(this.type)
    this.timers = setInterval(this.getproduct, 5000)
    // this.initwk()
  },
  beforeDestroy() {
    if (this.timers) {
      clearInterval(this.timers)
      this.timers = null
    }
  },
  beforeRouteLeave(to, from, next) {
    next()
    if (this.timers) {
      clearInterval(this.timers)
      this.timers = null
    }
  },
  methods: {
    async getproduct(t) {
      t = this.type
      const { data } = await this.$http.post('/getgoodslist', {
        type: t,
      })
      if (data) {
        if (data.code === '200') {
          this.productlist = data.data
        } else {
          this.productlist = []
        }
      }
    },
    async getproducts(t) {
      t = this.type
      const { data } = await this.$http.post('/getgoodslist2', {
        type: t,
      })
      if (data) {
        if (data.code === '200') {
          this.productlist = data.data
          this.productlist2 = data.data
          this.showmy = true
        }
      }
    },
    async getzxlist() {
      const { data } = await this.$http.get('/home/news/zxlist')
      if (data) {
        if (data.code === 200) {
          this.zxlist = data.data
        }
      }
    },
    detail(id) {
      this.$router.push({ path: '/trade' + id })
    },
    // 选项卡事件
    change(id) {
      if (id === 0) {
        clearInterval(this.timers)
        this.type = 'Collect'
        this.getproduct()
        this.timers = setInterval(this.getproduct, 5000)
      }
      if (id === 1) {
        clearInterval(this.timers)
        this.type = 'Crypto'
        this.getproduct()
        this.timers = setInterval(this.getproduct, 5000)
      }
      if (id === 2) {
        clearInterval(this.timers)
        this.type = 'Forex'
        this.getproduct()
        this.timers = setInterval(this.getproduct, 5000)
      }
      if (id === 3) {
        clearInterval(this.timers)
        this.type = 'Futures'
        this.getproduct()
        this.timers = setInterval(this.getproduct, 5000)
      }
    },
    // 添加自选
    add() {
      this.$router.push('/trade')
    },
    // 去交易页
    totrade(symbol) {
      this.$router.push({ path: '/trade', query: { symbol: symbol } })
    },
    initwk() {
      this.wk = new WebSocket(this.wsurl + '/wssss:8081')
      this.wk.onmessage = this.wkonmessage
    },
    wkonmessage(e) {
      this.productlist = JSON.parse(e.data)
      this.zxlist.map((item) => {
        this.productlist.forEach((p) => {
          if (p.product_title === item.product_title) {
            item.change = p.change
            item.current = p.current
          }
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
*,
:after,
:before {
  box-sizing: border-box;
  margin: 0;
}
.header {
  width: 100%;
  background-color: #000;
}
.van-nav-bar {
  position: relative;
  z-index: 1;
  line-height: 22px;
  text-align: left;
  background-color: #000000;
  -webkit-user-select: none;
  user-select: none;
}
/deep/ .van-nav-bar__title {
  max-width: 60%;
  margin-left: 20px;
  color: #323233;
  font-weight: 500;
  font-size: 28px;
}
/deep/ .van-nav-bar__content {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 50px;
  line-height: 50px;
  padding-top: 15px;
}
/deep/ .van-tabs__nav {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background-color: #000000;
  -webkit-user-select: none;
  user-select: none;
}
.van-hairline--bottom::after {
  border-bottom-width: 0px;
}
/deep/.van-tabs__nav--card {
  border: none;
  margin: 1rem 0 0 0;
}
/deep/.van-tabs__wrap {
  height: 51px;
}
/deep/.van-tabs__nav--card .van-tab {
  border: none;
}
/deep/.van-tabs__nav--card .van-tab.van-tab--active {
  background-color: #1a1a1a;
}
/deep/.van-tab {
  border-radius: 31px;
  background-color: #000;
  height: 2.4rem;
  width: 0.6rem;
  line-height: 2.4rem;
  margin: 0 0.2rem;
  //color: black;
  color: #ffffff4d;
}
.rotate-90 {
  transform: rotate(90deg);
}
.maincontent {
  padding: 50px 5%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-size: 0.93333rem;
  background: #000;
  /deep/.van-tabs__nav--line {
    box-sizing: initial;
    height: 100%;
    padding-bottom: 15px;
  }
  /deep/.van-tab--active {
    color: #ffffff;
  }
  // 新闻快讯
  .publish {
    height: 7.2rem;
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
    border-bottom: 0.02667rem solid #e5e5e5;
    display: flex;
    justify-content: center;
    align-content: center;
    .publish-msg {
      height: 80%;
      color: #000;
      font-size: 0.8rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      span {
        line-height: 1.25rem;
      }
    }
  }
  // 自选  // 市场
  .currency-title {
    margin-top: 0.5rem;
    margin-bottom: 0.4rem;
    font-size: 0.8rem;
    color: #b2b2b2;
    span {
      font-size: 0.875rem;
    }
  }
  .currency-Increase {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    line-height: 1.33333rem;
    border-bottom: 0.02667rem solid #e5e5e5;
    .currency-btn {
      border: none;
      border-radius: 0.26667rem;
      width: 5.4rem;
      height: 2.13333rem;
      color: #fff;
      font-size: 1rem;
    }
  }
  // 添加按钮
  .click-add {
    padding-top: 1.5rem;
  }
}
</style>
